// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

// TODO(matv): Update this implementation to use the 'core' card component

export const UseCaseGuideCards: MarkdocTagRegistration = {
  tag: 'use-case-guide-cards',
  component: 'UseCaseGuideCards',
};

export const UseCaseGuideCard: MarkdocTagRegistration = {
  tag: 'use-case-guide-card',
  component: 'UseCaseGuideCard',
  attributes: {
    title: {
      type: String,
      required: true,
      description: 'Title of the card',
      localizable: true,
    },
    href: {
      type: Href,
      required: true,
      description: 'URL that clicking the card will take you to',
    },
    companyIcon: {
      type: String,
      required: false,
      description: 'A company name to show the logo of',
    },
    exampleText: {
      type: String,
      required: false,
      description: 'Text to show next to the company icon',
      localizable: true,
    },
    showPill: {
      type: Boolean,
      required: false,
      default: true,
      description:
        'If pill text is defined, pass in a variable to conditionally show the pill text.',
    },
    pillText: {
      type: String,
      required: false,
      localizable: true,
      description:
        'Set to show a badge of text. Can also use the showPill attribute to conditionally show the pill',
    },
  },
};
